/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetUniversitiesSummaryQueryResponse,
  GetUniversitiesSummaryQueryParams,
} from '../types/GetUniversitiesSummary'

function getGetUniversitiesSummaryUrl() {
  const res = { method: 'GET', url: `/api/v1/universities/summary/` as const }
  return res
}

/**
 * @summary Universities list summary (count of filtered rows)
 * {@link /api/v1/universities/summary/}
 */
export async function getUniversitiesSummary(
  params?: GetUniversitiesSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetUniversitiesSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetUniversitiesSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
